import enAlerts from "../../../../locales/en/alerts.json";
import enAuth from "../../../../locales/en/auth.json";
import enCommon from "../../../../locales/en/common.json";
import enExport from "../../../../locales/en/export.json";
import enLocations from "../../../../locales/en/locations.json";
import enMachines from "../../../../locales/en/machines.json";
import enMap from "../../../../locales/en/map.json";
import enMlExports from "../../../../locales/en/mlExports.json";
import enPolygon from "../../../../locales/en/polygon.json";
import enSettings from "../../../../locales/en/settings.json";
import enUi from "../../../../locales/en/ui.json";

import ptAlerts from "../../../../locales/pt-BR/alerts.json";
import ptAuth from "../../../../locales/pt-BR/auth.json";
import ptCommon from "../../../../locales/pt-BR/common.json";
import ptExport from "../../../../locales/pt-BR/export.json";
import ptLocations from "../../../../locales/pt-BR/locations.json";
import ptMachines from "../../../../locales/pt-BR/machines.json";
import ptMap from "../../../../locales/pt-BR/map.json";
import ptMlExports from "../../../../locales/pt-BR/mlExports.json";
import ptPolygon from "../../../../locales/pt-BR/polygon.json";
import ptSettings from "../../../../locales/pt-BR/settings.json";
import ptUi from "../../../../locales/pt-BR/ui.json";

/**
 * One namespace per feature module, matching `src/modules/*`. A string lives in
 * the namespace of the module that renders it; `common` is for app chrome that
 * belongs to no single module.
 */
export const defaultNS = "common";

export const resources = {
  en: {
    alerts: enAlerts,
    auth: enAuth,
    common: enCommon,
    export: enExport,
    locations: enLocations,
    machines: enMachines,
    map: enMap,
    mlExports: enMlExports,
    polygon: enPolygon,
    settings: enSettings,
    ui: enUi,
  },
  "pt-BR": {
    alerts: ptAlerts,
    auth: ptAuth,
    common: ptCommon,
    export: ptExport,
    locations: ptLocations,
    machines: ptMachines,
    map: ptMap,
    mlExports: ptMlExports,
    polygon: ptPolygon,
    settings: ptSettings,
    ui: ptUi,
  },
} as const;

/**
 * Autonyms: a language is always listed in its own language, so these are not
 * translatable strings and deliberately do not live in the locale files.
 *
 * The flags are regional-indicator pairs, written as escapes so the source
 * stays ASCII. `en` carries the US flag because the app's own `en` formatting
 * is US convention (MM/dd/yyyy); a language is not owned by a country, so the
 * flag is decoration beside the autonym, never the thing that identifies it.
 * Some platforms (notably Chrome on Windows) render these as the letters "US"
 * and "BR" rather than flags, which is why the name always travels with it.
 */
export const SUPPORTED_LOCALES = [
  { code: "en", label: "English", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "pt-BR", label: "Português (Brasil)", flag: "\u{1F1E7}\u{1F1F7}" },
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]["code"];

export const FALLBACK_LOCALE: SupportedLocale = "en";
